import i18n from 'translation/config';

type LocaleConfig = {
  locale: string;
  currency: string;
};

type SupportedLanguages = 'en' | 'es' | 'pt';

const localeCurrencyMap: Record<SupportedLanguages, LocaleConfig> = {
  en: { locale: 'en-US', currency: 'USD' },
  es: { locale: 'es-AR', currency: 'ARS' },
  pt: { locale: 'pt-BR', currency: 'BRL' },
};

export function formatMoney(value: number | string, lang: SupportedLanguages = 'es'): string {
  const numberValue = typeof value === 'string' ? parseFloat(value) : value;
  const { locale, currency } = localeCurrencyMap[lang] ?? localeCurrencyMap['es'];

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(numberValue);
}

export function formatMoneyAuto(value: number | string): string {
  const currentLang = (i18n?.language || 'es') as SupportedLanguages;
  return formatMoney(value, currentLang);
}
